<template>
    <card-expandable
        v-if="localChat"
        toggle-color="gray-100"
        with-collapse-arrow
        with-content
        :is-opened-at-start="localNote !== ''"
    >
        <text-decorator :size="Size.xs">
            Notitie
        </text-decorator>

        <template #content>
            <flex-container>
                <input-group v-model="localNote">
                    <template #input>
                        <text-area-input height="120px" placeholder="Voeg een notitie toe" />
                    </template>
                </input-group>

                <flex-container justify-content="flex-end">
                    <button-block @loading="saveNote($event)">
                        Opslaan
                    </button-block>
                </flex-container>
            </flex-container>
        </template>
    </card-expandable>
</template>

<script setup lang="ts">
    import { ButtonState, type ButtonStateChangedEvent, NotificationBlock, Size, TextAreaInput, useNotify } from '@keyvue/one-ui';
    import { ChangeNoteCommand, Chat, ChatId } from '@keyvue/one-api-client';
    import useClient from '@/services/keyvue-api/composables/useClient';
    import CheckIcon from '@keyvue/one-awesome-icons/icons/regular/check.svg?component';
    import { onMounted, ref } from 'vue';
    import { onBeforeRouteUpdate } from 'vue-router';

    const props = defineProps<{ chat: Chat }>();

    const { client } = useClient();
    const { notify } = useNotify();

    const localNote = ref<string>('');
    const localChat = ref<Chat | null>(null);

    onMounted(async () => {
        await load(props.chat.id);
    });

    onBeforeRouteUpdate(async (to) => {
        const paramChatId = to.params.chatId?.toString();

        if (paramChatId === undefined) {
            return;
        }

        await load(new ChatId(paramChatId));
    });

    async function load(chatId: ChatId) {
        localChat.value = await client.get(Chat, chatId);
        localNote.value = localChat.value.note;
    }

    async function saveNote(event: ButtonStateChangedEvent) {
        const command = new ChangeNoteCommand(
            props.chat.id,
            localNote.value,
        );

        await client.dispatch(command);

        notify({
            component: NotificationBlock,
            props: {
                color: 'green-500',
                title: 'Notitie opgeslagen!',
                text: 'De notitie is succesvol opgeslagen!',
                icon: CheckIcon,
                isCustomIcon: true,
            },
            duration: 3000,
        });

        event.button.setState(ButtonState.completed);
    }
</script>

<style lang="scss" scoped>
    .chat-tags-expandable-card {
        &__tag-dot {
            width: 5px;
            height: 5px;
            border-radius: 50%;
        }
    }
</style>
